import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'yesterday'
	| 'now'
	| 'compactMinute'
	| 'compactHour'
	| 'compactDay'
	| 'compactWeek'
	| 'compactMonth'
	| 'compactNow';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		yesterday: {
			id: 'ai-mate.date-time-utils.time.yesterday',
			defaultMessage: 'Yesterday',
			description: 'Relative time label, yesterday',
		},
		now: {
			id: 'ai-mate.date-time-utils.time.now',
			defaultMessage: 'Just now',
			description: 'Relative time label, less than 1 minute',
		},
		compactMinute: {
			id: 'ai-mate.date-time-utils.time.compact-minute',
			defaultMessage: '{value}m',
			description: 'Compact relative time label in minutes, for example 14m',
		},
		compactHour: {
			id: 'ai-mate.date-time-utils.time.compact-hour',
			defaultMessage: '{value}h',
			description: 'Compact relative time label in hours, for example 2h',
		},
		compactDay: {
			id: 'ai-mate.date-time-utils.time.compact-day',
			defaultMessage: '{value}d',
			description: 'Compact relative time label in days, for example 2d',
		},
		compactWeek: {
			id: 'ai-mate.date-time-utils.time.compact-week',
			defaultMessage: '{value}w',
			description: 'Compact relative time label in weeks, for example 1w',
		},
		compactMonth: {
			id: 'ai-mate.date-time-utils.time.compact-month',
			defaultMessage: '{value}mo',
			description: 'Compact relative time label in months, for example 2mo',
		},
		compactNow: {
			id: 'ai-mate.date-time-utils.time.compact-now',
			defaultMessage: 'now',
			description: 'Compact relative time label for an update less than one minute ago',
		},
	});

export default message;
